import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { DealParties } from '@repo/types'

/**
 * Dashboard (`GET /dashboard/stats`). Kľúč zdieľajú mutácie úloh a udalostí
 * (tasks.ts, events.ts) — dashboard zobrazuje moje úlohy a obhliadky týždňa.
 */

export interface DashboardStats {
  tenantName: string
  properties: { total: number; active: number; sold: number; rented: number }
  /** Osoby v scope zoznamu Kontakty. */
  contacts: { total: number; new: number; inProgress: number }
  deals: { wonThisYear: number }
  users: { total: number }
  /** 5 najnovších nekontaktovaných osôb (stav NEW); e-mail je '' ak chýba. */
  recentContacts: Array<{
    id: string; firstName: string; lastName: string; email: string
    customerType: string | null; source: string | null; createdAt: string; status: string
  }>
  recentProperties: Array<{
    id: number; title: string; price: number; currency: string
    status: string; createdAt: string
  }>
  myTasks: Array<{
    id: string; title: string; priority: string; status: string
    dueAt: string | null
    deal?: { id: string; title: string }
  }>
  weekViewings: Array<{
    id: string; scheduledAt: string; duration: number; status: string
    property?: { id: number; title: string; city: string }
    deal?: ({ id: string; title: string } & DealParties<{ id: string; firstName: string; lastName: string }>) | null
  }>
  myMonthStats: {
    totalDeals: number; contacted: number; viewings: number
    won: number; lost: number; wonCommission: number
  }
}

export const dashboardKeys = {
  stats: ['dashboard-stats'] as const,
}

export function useDashboardStats() {
  return useQuery<DashboardStats>({
    queryKey: dashboardKeys.stats,
    queryFn: async () => {
      const { data } = await api.get<DashboardStats>('/dashboard/stats')
      return data
    },
  })
}
